import { makeStyles, Grid, Menu, MenuItem, Typography } from '@material-ui/core';
import LogoDevIcon from '@mui/icons-material/LogoDev';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import TuneIcon from '@mui/icons-material/Tune';
import React, { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import { useDispatch, useSelector } from 'react-redux';
import LogoText from '../../assets/SvgLogoText';
import Logo from '../../assets/SvgLogo';
import service from '../../apis/service';
import { getDEVTabId, getMainTabID, setDevAccess, showDevPanel } from '../../redux/actions/DealershipActions';
import { apiEndpoints } from '../../constants/apiEndpoints';

const useStyles = makeStyles(() => ({
  dropdownIcon: {
    marginRight: '10px',
    fontSize: '10px',
    cursor: 'pointer',
  },
  emailText: {
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '15px',
    textAlign: 'center',
  },
  imageLogo: {
    height: '32px',
    marginRight: '19px',
  },
  imageText: {
    height: '12px',
  },
  leftContent: {
    height: '28px',
    marginLeft: '70px',
    marginTop: '16px',
    marginBottom: '16px',
  },
  leftContentHolder: {
    height: '9vh',
    marginRight: '6%',
    flexGrow: '0',
    flexBasis: '55%',
    maxWidth: '80%',
  },
  lIcon: {
    backgroundColor: '#C4C4C4',
    borderRadius: '50%',
    height: '36px',
    width: '36px',
    margin: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '12px',
    fontSize: '14px',
    fontWeight: 600,
  },
  mainContent: {
    height: '9vh',
    maxHeight: '9vh',
    background: '#FFFFFF',
    boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.1)',
  },
  rightContent: {
    marginRight: '70px',
    marginTop: '8px',
    marginBottom: '16px',
    padding: '0px 4px 4px 4px',
    width: '80px',
    height: '44px',
    background: '#F4F4F4',
    borderRadius: '32px',
  },
  rightContentHolder: {
    height: '60px',
    marginRight: '2%',
    flexGrow: '0',
    flexBasis: '9%',
    maxWidth: '9%',
  },
  card: {
    width: '100%',
    height: '30px',
    marginLeft: '6px',
    marginRight: '6px',
    bottom: '0%',
    background: '#FFFFFF',
    border: '2px solid #FAFAFA',
    boxSizing: 'border-box',
    cursor: 'pointer',
  },
  cardSelected: {
    width: '100%',
    height: '30px',
    marginLeft: '6px',
    marginRight: '6px',
    bottom: '0%',
    background: '#FFFFFF',
    boxSizing: 'border-box',
    cursor: 'pointer',
    border: '2px solid #622FEE',
  },
  icon: {
    width: '20px',
    height: '20px',
  },
}));
const TopbarMenu = () => {
  const dispatch = useDispatch();
  const devAccess = useSelector((state) => state.setDevAccess?.devAccess);
  const isDevPanelOpen = useSelector((state) => state.showDevPanel?.isDevPanelOpen);
  const devTabID = useSelector((state) => state.getDEVTabId);

  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const cookies = new Cookies();
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleLogoutClick = () => {
    cookies.remove('access_token');
    cookies.remove('auth_expires');
    cookies.remove('refresh_token');
    cookies.remove('media_token');
    window.location.pathname = '/';
  };

  const checkAccess = async () => {
    await service
      .get(apiEndpoints.CHECK_ACCESS)
      .then((res) => {
        if (res.access) {
          dispatch(setDevAccess(true));
        } else {
          dispatch(setDevAccess(false));
        }
      })
      .catch(() => {
        dispatch(setDevAccess(false));
      });
  };

  useEffect(() => {
    checkAccess();
  }, []);

  const devMenuItems = (
    <>
      <Grid item>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          className={devTabID === 2 || devTabID === 6 ? classes.cardSelected : classes.card}
          onClick={() => {
            dispatch(getDEVTabId(2));
            dispatch(getMainTabID(6));
          }}
        >
          <Grid item>
            <TuneIcon className={classes.icon} />
          </Grid>
          <Grid item>
            <Typography className={classes.tabText}> Custom</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          className={devTabID === 0 ? classes.cardSelected : classes.card}
          onClick={() => dispatch(getDEVTabId(0))}
        >
          <Grid item>
            <LogoDevIcon className={classes.icon} />
          </Grid>
          <Grid item>
            <Typography className={classes.tabText}> Logs Table</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          className={devTabID === 3 ? classes.cardSelected : classes.card}
          onClick={() => dispatch(getDEVTabId(3))}
        >
          <Grid item>
            <LogoDevIcon className={classes.icon} />
          </Grid>
          <Grid item>
            <Typography className={classes.tabText}> Zombie Table</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          className={devTabID === 4 ? classes.cardSelected : classes.card}
          onClick={() => dispatch(getDEVTabId(4))}
        >
          <Grid item>
            <LogoDevIcon className={classes.icon} />
          </Grid>
          <Grid item>
            <Typography className={classes.tabText}> Dealership List</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          className={devTabID === 1 ? classes.cardSelected : classes.card}
          onClick={() => dispatch(getDEVTabId(1))}
        >
          <Grid item>
            <FileUploadIcon className={classes.icon} />
          </Grid>
          <Grid item>
            <Typography className={classes.tabText}> Dev Apis</Typography>
          </Grid>
        </Grid>
      </Grid>
    </>
  );

  return (
    <Grid container direction="row" justifyContent="space-between" alignItems="center" className={classes.mainContent}>
      <Grid item className={classes.leftContentHolder}>
        <Grid container direction="row" alignItems="center" className={classes.leftContent}>
          <Grid item>
            <Logo className={classes.imageLogo} />
          </Grid>
          <Grid item>
            <LogoText className={classes.imageText} />
          </Grid>
          &nbsp; &nbsp;
          {isDevPanelOpen ? devMenuItems : null}
        </Grid>
      </Grid>
      <Grid item>
        <Grid container direction="row" justifyContent="center" alignItems="center" className={classes.rightContent}>
          <Grid item className={classes.lIcon}>
            I
          </Grid>
          <Grid item className={classes.dropdownIcon} onClick={handleClick}>
            &#9660;
          </Grid>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            style={{
              marginTop: '5.5vh',
            }}
          >
            {devAccess ? (
              <MenuItem
                value="Show Panel"
                className={classes.menuRoot}
                onClick={() => {
                  if (isDevPanelOpen) {
                    dispatch(getMainTabID(1));
                  } else {
                    dispatch(getDEVTabId(2));
                    dispatch(getMainTabID(6));
                  }
                  dispatch(showDevPanel());
                }}
              >
                {!isDevPanelOpen ? 'Show Dev Panel' : 'Hide Dev Panel'}
              </MenuItem>
            ) : null}
            <MenuItem value="Logout" className={classes.menuRoot} onClick={handleLogoutClick}>
              Logout
            </MenuItem>
          </Menu>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TopbarMenu;
